import { render, staticRenderFns } from "./QuestionCall.vue?vue&type=template&id=c90c98cc"
import script from "./QuestionCall.vue?vue&type=script&lang=js"
export * from "./QuestionCall.vue?vue&type=script&lang=js"
import style0 from "./QuestionCall.vue?vue&type=style&index=0&id=c90c98cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports